import { asDecimal } from '@/lib/helpers/numeric'

/**
 * Conversion factor kg to lbs
 */
const KG_TO_LBS = 2.20462

/**
 * Convert weight between kg and lbs
 *
 * @param {number} value - Value to convert
 * @param {string} unitIn - Source unit ('kg' or 'lbs')
 * @param {string} unitOut - Target unit ('kg' or 'lbs')
 * @param {number|null} decimals - Number of decimals (null to disable)
 * @param {boolean} returnString - If true, return formatted string
 * @returns {object|string}
 */
export const convertWeight = (value, unitIn = 'kg', unitOut = 'lbs', decimals = 2, returnString = false) => {
    unitOut = unitOut ?? 'kg'

    let weight = {
        value: value,
        unit: unitIn,
    }

    if (unitIn !== unitOut) {
        if (unitIn === 'kg' && unitOut === 'lbs') {
            weight.value *= KG_TO_LBS
            weight.unit = 'lbs'
        } else if (unitIn === 'lbs' && unitOut === 'kg') {
            weight.value /= KG_TO_LBS
            weight.unit = 'kg'
        }
    }

    if (decimals !== null) {
        weight.value = asDecimal(weight.value, decimals)
    }

    return returnString ? `${weight.value} ${weight.unit}` : weight
}
